import ExpectedSalary from "../../components/ExpectedSalary";
import { order } from "../SmartSearchParammeter";
export default async function ExpectedSalarySearchConfig(key) {
  return {
    description: "Expected Salary",
    id: "lowerBoundSalary",
    initial: undefined,
    type: order.third,
    handleValues: (searchObject) => {
      return;
    },

    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <ExpectedSalary searchObject={searchObject} onChange={onChange} t={t} />
      </div>
    ),
    operation: ["Between"],
    list: [],
    handleValues: (searchObject) => {
      return;
    },

    handler: function (searchObj, value) {
      searchObj["lowerBoundSalary"] = value[0];
      searchObj["upperBoundSalary"] = value[1] ? value[1] : null;
    }
  };
}
